var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCarousel
    ? _c(
        "div",
        {
          ref: "carousel",
          staticClass: "ns-carousel",
          class: {
            "ns-carousel-multiple": _vm.multiple,
            "ns-carousel-vertical": _vm.vertical
          }
        },
        [
          _vm.showControls
            ? _c(
                "div",
                {
                  staticClass: "ns-carousel-left ns-carousel-control",
                  attrs: { disabled: _vm.disablePrevious },
                  on: { click: _vm.previous }
                },
                [
                  _vm._t("left", [
                    _c("NsIcon", {
                      attrs: {
                        "icon-name": "icon-chevron-left",
                        size: "icon-lg"
                      }
                    })
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ns-carousel-content-window",
              class: {
                "ns-carousel-grabbing": _vm.grabbing
              },
              on: {
                mousemove: _vm.handleMouseMove,
                mousedown: _vm.handleMouseDown,
                mouseup: _vm.handleMouseUp,
                mouseleave: _vm.handleMouseLeave,
                touchmove: _vm.handleTouchMove,
                touchend: _vm.handleTouchEnd
              }
            },
            [
              _c(
                "div",
                {
                  ref: "content",
                  staticClass: "ns-carousel-content",
                  style: _vm.contentStyle
                },
                [
                  _c(
                    "NsCarouselItems",
                    {
                      attrs: { spacing: _vm.spacing, vertical: _vm.vertical },
                      on: { "items-updated": _vm._updateContentWidth }
                    },
                    [_vm._t("default")],
                    2
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.showControls
            ? _c(
                "div",
                {
                  staticClass: "ns-carousel-right ns-carousel-control",
                  attrs: { disabled: _vm.disableNext },
                  on: { click: _vm.next }
                },
                [
                  _vm._t("right", [
                    _c("NsIcon", {
                      attrs: {
                        "icon-name": "icon-chevron-right",
                        size: "icon-lg"
                      }
                    })
                  ])
                ],
                2
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }